module.exports = __webpack_public_path__ + "static/media/ab_gauge_bg.14639d1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/meter/ab_gauge_bg.png
// module id = 388
// module chunks = 0